import { FormikContextType } from 'formik/dist/types'
import { useEffect } from 'react'

const getFieldErrorNames = (formikErrors: any) => {
  const transformObjectToDotNotation = (obj: any, prefix = '', result: any[] = []) => {
    Object.keys(obj).forEach((key) => {
      const value = obj[key]
      if (!value) return

      const nextKey = prefix ? `${prefix}.${key}` : key
      if (typeof value === 'object') {
        transformObjectToDotNotation(value, nextKey, result)
      } else {
        result.push(nextKey)
      }
    })

    return result
  }

  return transformObjectToDotNotation(formikErrors)
}

const compareElementDocumentOrder = (a: Element, b: Element) => {
  const p = a.compareDocumentPosition(b)
  if (p & Node.DOCUMENT_POSITION_PRECEDING) {
    return 1
  } else if (p & Node.DOCUMENT_POSITION_FOLLOWING) {
    return -1
  }
  return 0
}

export default function useFocusInputWithError(formik: FormikContextType<any>) {
  const submitCount = formik.isSubmitting ? formik.submitCount - 1 : formik.submitCount
  useEffect(() => {
    if (formik.isValid) {
      return
    }

    const fieldErrorNames = getFieldErrorNames(formik.errors)

    const elements = fieldErrorNames
      .map((name) => {
        let element = document.querySelector(`[data-focus-input='${name}']`)
        if (!element) {
          element = document.querySelector(`[name='${name}']`)
        }
        return element
      })
      .filter(Boolean) as Element[]

    elements.sort(compareElementDocumentOrder)

    if (elements.length) {
      const detailsElement = elements[0].closest('details')
      if (detailsElement) {
        detailsElement.setAttribute('open', 'true')
      }

      elements[0]!.scrollIntoView()
      ;(elements[0] as any).focus?.()
    }
  }, [submitCount])
}
